import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

const ProductSwatchSelection = ({
  swatches = [],
  selectedItemName,
  label = '',
  labelFirst = false,
  nameFirst = false,
  separator = ':',
}) => (
  <div className="product-swatch-selection">
    {nameFirst ? (
      <Fragment>
        <span className="product-swatch-selection__name">
          {selectedItemName}
        </span>
        {' '}

        {labelFirst && (
          <Fragment>
            <span className="product-swatch-selection__label">
              {label}
            </span>
            <span className="product-swatch-selection__separator">
              {separator}{' '}
            </span>
          </Fragment>
        )}
        <span className="product-swatch-selection__number">
          {swatches.length}
        </span>
        {!labelFirst && (
          <Fragment>
            <span className="product-swatch-selection__separator">
              {separator}
            </span>
            <span className="product-swatch-selection__label">
              {' '}{label}
            </span>
          </Fragment>
        )}
      </Fragment>
    ) : (
      <Fragment>
        {labelFirst && (
          <Fragment>
            <span className="product-swatch-selection__label">
              {label}
            </span>
            <span className="product-swatch-selection__separator">
              {separator}{' '}
            </span>
          </Fragment>
        )}
        <span className="product-swatch-selection__number">
          {swatches.length}
        </span>
        {!labelFirst && (
          <Fragment>
            <span className="product-swatch-selection__label">
              {' '}{label}
            </span>
            <span className="product-swatch-selection__separator">
              {separator}
            </span>
          </Fragment>
        )}
        <span className="product-swatch-selection__name">
          {selectedItemName}
        </span>
      </Fragment>
    )}

  </div>
);

ProductSwatchSelection.propTypes = {
  swatches: PropTypes.arrayOf(PropTypes.shape({
    // TODO: define proper shape structure for swatch object
    skuColor: PropTypes.string,
    sku: PropTypes.string,
  })).isRequired,
  selectedItemName: PropTypes.string,
  label: PropTypes.string,
  labelFirst: PropTypes.bool,
  nameFirst: PropTypes.bool,
  separator: PropTypes.string,
};

export default ProductSwatchSelection;
